var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 65,
    viewBox: "0 0 54 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.858337,
    y: 1.0448,
    width: 52.4547,
    height: 62.7759,
    rx: 4.75,
    stroke: "url(#paint0_radial_189:151)",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5857 33.9183V36.9183C35.5857 38.2183 32.4517 39.9183 28.5857 39.9183C24.7197 39.9183 21.5857 38.2183 21.5857 36.9183V34.4183",
    stroke: "url(#paint1_radial_189:151)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8797 34.6774C22.7447 35.8254 25.4197 36.9024 28.5857 36.9024C32.4517 36.9024 35.5857 35.2964 35.5857 33.9164C35.5857 33.1414 34.5987 32.2924 33.0497 31.6964",
    stroke: "url(#paint2_radial_189:151)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5857 28.9183V31.9183C32.5857 33.2183 29.4517 34.9183 25.5857 34.9183C21.7197 34.9183 18.5857 33.2183 18.5857 31.9183V28.9183",
    stroke: "url(#paint3_radial_189:151)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5857 31.9023C29.4517 31.9023 32.5857 30.2963 32.5857 28.9163C32.5857 27.5353 29.4517 25.9183 25.5857 25.9183C21.7197 25.9183 18.5857 27.5353 18.5857 28.9163C18.5857 30.2963 21.7197 31.9023 25.5857 31.9023Z",
    stroke: "url(#paint4_radial_189:151)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1321 23.12L17.0809 42.1893",
    stroke: "url(#paint5_radial_189:151)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_189:151",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.847 61.2791) rotate(-67.7929) scale(82.4166 73.1884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_189:151",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.0857 39.6536) rotate(-41.3016) scale(10.9622 13.7942)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_189:151",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.3062 36.6727) rotate(-37.9064) scale(10.2182 12.5705)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_189:151",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.0857 34.6536) rotate(-41.3016) scale(10.9622 13.7942)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_189:151",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.0857 31.6383) rotate(-41.2258) scale(10.9495 13.7734)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_189:151",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0937 41.348) rotate(-58.3983) scale(26.999 30.5802)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeIcon);
export default __webpack_public_path__ + "static/media/free_icon.e81b8932.svg";
export { ForwardRef as ReactComponent };